document.addEventListener('DOMContentLoaded', function () {

  const drawer = document.getElementById('pw-drawer');
  const overlay = document.getElementById('pw-overlay');
  const closeBtn = document.querySelector('.pw-close');
  const wrapper = document.querySelector('#pw-drawer .pw-wrapper');
  const topLinksContainer = document.querySelector('#pw-drawer .pw-top-links');
  const nextBtn = document.querySelector('.pw-top-next');

  if (!drawer || !overlay || !wrapper) return;

  const number = (wrapper.dataset.number || '').replace(/\D/g, '');
  const items = wrapper.querySelectorAll('.pw-item');
  const contactBox = wrapper.querySelector('.pw-contact-box');

  const isMobile = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  let drawerHistoryPushed = false;

  const allTopLinks = window.WHATSAPP_TOP_LINKS || [];

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  let topIndex = 0;
  let shuffledLinks = [];

  function renderTopLinks(reset = false) {

    if (!topLinksContainer) return;

    if (reset || !shuffledLinks.length) {
      shuffledLinks = shuffle([...allTopLinks]);
      topIndex = 0;
    }

    topLinksContainer.innerHTML = '';

    const fragment = document.createDocumentFragment();
    const batch = shuffledLinks.slice(topIndex, topIndex + 4);

    batch.forEach(link => {
      const a = document.createElement('a');
      a.href = link.url;
      a.className = 'pw-top-item suggested';
      a.textContent = link.text;
      fragment.appendChild(a);
    });

    topLinksContainer.appendChild(fragment);

    setTimeout(() => {
      topLinksContainer
        .querySelectorAll('.pw-top-item')
        .forEach(btn => btn.classList.remove('suggested'));
    }, 1200);

    topIndex += 4;

    if (topIndex >= shuffledLinks.length) {
      shuffledLinks = shuffle([...allTopLinks]);
      topIndex = 0;
    }
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      renderTopLinks();
    });
  }

  function animateItems() {

    items.forEach(item => item.classList.remove('show'));
    if (contactBox) contactBox.classList.remove('show');

    drawer.offsetHeight;

    items.forEach((item, index) => {
      setTimeout(() => item.classList.add('show'), 120 * index);
    });

    if (contactBox) {
      setTimeout(() => {
        contactBox.classList.add('show');
      }, 120 * items.length + 300);
    }
  }

  function openDrawer() {

    renderTopLinks(true);

    drawer.classList.add('active');
    overlay.classList.add('active');

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (isMobile && !drawerHistoryPushed) {
      history.pushState({ drawerOpen: true }, '');
      drawerHistoryPushed = true;
    }

    setTimeout(animateItems, 200);
  }

  function closeDrawer() {

    drawer.classList.remove('active');
    overlay.classList.remove('active');

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    items.forEach(item => item.classList.remove('show'));
    if (contactBox) contactBox.classList.remove('show');

    if (isMobile && drawerHistoryPushed) {
      drawerHistoryPushed = false;
      history.back();
    }
  }

  document.addEventListener('click', function (e) {

    const openTrigger = e.target.closest('.js-open-whatsapp');
    if (openTrigger) {
      e.preventDefault();
      openDrawer();
      return;
    }

    const whatsappBtn = e.target.closest('.pw-item:not(.pw-email-item)');

    if (whatsappBtn) {

      // 🚫 BLOQUEIA ENTREGA EXPRESSA
      if (whatsappBtn.classList.contains('pw-entrega-trigger')) {

        e.preventDefault();
        e.stopPropagation();

        const popup = document.getElementById('popup-entrega');
        if (popup) {
          popup.classList.add('active');
          document.body.style.overflow = 'hidden';
        }

        return;
      }

      if (number) {
        const message = encodeURIComponent(whatsappBtn.dataset.message || '');
        window.open(`https://api.whatsapp.com/send?phone=${number}&text=${message}`, '_blank');
      }
    }

    const emailBtn = e.target.closest('.pw-email-item');
    if (emailBtn) {
      const email = emailBtn.dataset.email;
      const subject = encodeURIComponent(emailBtn.dataset.subject || '');
      const body = encodeURIComponent(emailBtn.dataset.body || '');
      window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
    }

  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  window.addEventListener('popstate', function () {

    if (!isMobile) return;

    if (drawer.classList.contains('active')) {
      drawer.classList.remove('active');
      overlay.classList.remove('active');

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';

      items.forEach(item => item.classList.remove('show'));
      if (contactBox) contactBox.classList.remove('show');

      drawerHistoryPushed = false;
    }

  });

});